module.exports = "//static.hsappstatic.net/LoginUI/static-1.15632/img/HubSpot-sprocket-color.png"